<template>
    <div>
        <p v-html="notification.message" class="darkest" :class="{'pointer':notification.metadata && notification.metadata.pendingReservation}" @click="openReservation"></p>
        <button v-if="showInvoiceBtn" class="btn tertiary narrow my-1" @click="openReservation">View booking</button>
    </div>
</template>

<script>
export default {
    props:{
        notification: {
            type: Object,
        }
    },
    computed: {
        showInvoiceBtn: function () {
            if(this.notification.metadata && this.notification.metadata.pendingReservation){
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        openReservation: function () {
            this.$emit('clicked')
            if(this.notification.metadata.pendingReservation){
                this.$router.push({ path: '/reservations/view/'+this.notification.metadata.pendingReservation });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// bodyReservationPending.vue?94a24c58